module.exports = __webpack_public_path__ + "static/img/penny_pictgrid12_800x755.1cff5ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid12_800x755.jpg
// module id = Px7S
// module chunks = 0